import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { ContractWidget } from '@models/contract-widgets';
import { Contract } from '@models/contract';
import { InsurenetInterfaceService } from 'app/core/insurenet-interface/insurenet-interface.service';
import { finalize } from 'rxjs';
import { TabletPlusInsuranceWidgetDetailComponent } from '../tablet-plus-insurance-widget-detail/tablet-plus-insurance-widget-detail.component';
import { ContractsService } from 'app/customer-portal';

@Component({
    selector: 'app-tablet-plus-insurance-widget',
    templateUrl: './tablet-plus-insurance-widget.component.html',
    styleUrl: './tablet-plus-insurance-widget.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TabletPlusInsuranceWidgetDetailComponent],
})
export class TabletPlusInsuranceWidgetComponent implements ContractWidget {
    private insurenetInterfaceService = inject(InsurenetInterfaceService);
    private contractService = inject(ContractsService);

    public contract = input.required<Contract>();

    protected submitting = signal<boolean>(false);

    protected tablets = computed(() =>
        this.contract().objectPool.map((object) => ({
            id: object.Id,
            title: `${object.ObjectDescription} Tablet`,
            price: object.ObjectValue,
            serialNumber: object.ObjectDetail,
        })),
    );

    protected updateTabletInformation(tabletToUpdateId: number, event: { serialNumber: string }): void {
        const objectPool = [
            ...this.contract().objectPool.map((object) => {
                if (object.Id !== tabletToUpdateId) {
                    return object;
                } else {
                    return {
                        ...object,
                        ObjectDetail: event.serialNumber,
                    };
                }
            }),
        ];

        this.submitting.set(true);

        this.insurenetInterfaceService
            .updateObjectPool(this.contract().id, objectPool)
            .pipe(finalize(() => this.submitting.set(false)))
            .subscribe(() => {
                this.contractService.updateInsuredObjects(this.contract().id, objectPool);
            });
    }
}
